import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { GetShippingCompaniesResponse } from "@/main/models/response/packingTrackingHistoryResponse";

export abstract class IShippingCompanyApi {
	abstract getShippingCompany(
		guidProcurementSupplier: string,
		guidPackingTrackingDelivery: string,
	): Promise<AxiosResponse<Result<GetShippingCompaniesResponse[]>>>;
}
